import type { DefaultError } from 'utils/errors';
import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next/types';

export const RESET_PASSWORD = 'state.persisted.RESET_PASSWORD';
export const RESET_PASSWORD_FAILURE = 'state.persisted.RESET_PASSWORD_FAILURE';

export interface ResetPassword {
	payload: {
		emailAddress: string;
		password: string;
		token: string;
		resetPasswordJwt?: string;
		createAnalyticsEvent?: CreateUIAnalyticsEvent;
		redirectUrl?: string | null;
	};
	type: typeof RESET_PASSWORD;
}

export const resetPassword = (
	emailAddress: string,
	password: string,
	token: string,
	resetPasswordJwt?: string,
	createAnalyticsEvent?: CreateUIAnalyticsEvent,
	redirectUrl?: string | null,
): ResetPassword => ({
	payload: {
		emailAddress,
		password,
		token,
		resetPasswordJwt,
		createAnalyticsEvent,
		redirectUrl,
	},
	type: RESET_PASSWORD,
});

export interface ResetPasswordFailure {
	payload: {
		error: DefaultError;
	};
	type: typeof RESET_PASSWORD_FAILURE;
}

export const resetPasswordFailure = (error: DefaultError): ResetPasswordFailure => ({
	payload: {
		error,
	},
	type: RESET_PASSWORD_FAILURE,
});
